module.exports = __webpack_public_path__ + "img/store-allocation.aba5561e.png";